import { categories } from '@/mocks/siteData';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20night%20sky%20filled%20with%20countless%20stars%20and%20nebula%2C%20artistic%20abstract%20cosmic%20landscape%2C%20deep%20space%20with%20warm%20golden%20and%20soft%20coral%20hues%2C%20dreamy%20celestial%20atmosphere%2C%20elegant%20composition%20with%20flowing%20light%20trails&width=1800&height=900&seq=hero-bg&orientation=landscape"
        alt="星空背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight">
            天美麻花星空影视
          </h1>
          <p className="mt-4 md:mt-5 text-base md:text-lg text-background-100/90 max-w-xl mx-auto">
            海量高清影视资源，电影、电视剧、综艺、动漫全覆盖<br />高清流畅不缓冲，随时随地畅享精彩
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="relative w-full max-w-md">
              <div className="w-5 h-5 flex items-center justify-center absolute left-4 top-1/2 -translate-y-1/2">
                <i className="ri-search-line text-foreground-400 text-base" />
              </div>
              <input
                type="text"
                placeholder="搜索电影、电视剧、综艺、动漫..."
                className="w-full pl-10 pr-4 py-3 rounded-full bg-background-50/95 text-sm text-foreground-800 placeholder:text-foreground-400 border border-background-200/50 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-shadow"
              />
            </div>
            <button className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              立即搜索
            </button>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium hover:bg-background-50/25 transition-colors border border-background-50/20 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`} />
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}